import { render, staticRenderFns } from "./CustomCertDns.vue?vue&type=template&id=4e7cf76c&scoped=true&"
import script from "./CustomCertDns.vue?vue&type=script&lang=js&"
export * from "./CustomCertDns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7cf76c",
  null
  
)

export default component.exports